import BigNumber from 'bignumber.js';
import { removeNeedlessZeros } from '.';

export const toDecimal = (value: string, places: number) => {
  const x = new BigNumber(value, 10);
  const power = new BigNumber(10, 10).exponentiatedBy(places * -1);
  const y = x.multipliedBy(power);
  return removeNeedlessZeros(y.toFixed(places));
};
